const BaseError = require('make-error').BaseError;

class LicenseDepletedError extends BaseError {
    constructor(
        errorMessage = 'All licenses are in use. Please contact support for more.'
    ) {
        super(errorMessage);
        this._isUserError = true;
    }
}

module.exports = LicenseDepletedError;
